<template>
  <div id="Hearder_company">
    <el-row type="flex" justify="center">
      <el-col
        :xs="22"
        :sm="22"
        :md="22"
        :lg="20"
        :xl="18"
      >
        <div class="header_content_company">
          <div class="left-wraper_companyhead">
              <img class="header_logo" :src="header_logo" alt="" @click="clickHeaderPic">
              <span class="header_title">{{title}}</span>
          </div>
          <div class="right-wraper_companyhead">
              <slot name="message-tip"></slot>
              <el-dropdown trigger="click">
                <div class="headerlogin">
                  <img :src="companyLogo?companyLogo:userHeadImage" class="avator" >
                  <span v-if="showUser" class="userName">{{user.userName | userNameFilter}}</span>
                  <span
                    v-if="!showUser"
                    class="login_register"
                    @click="goLogin"
                  >登录/注册</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu
                  slot="dropdown"
                  v-if="showUser"
                >
                  <el-dropdown-item>
                    <div @click="personInfo"><i class="el-icon-user"></i>&nbsp;个人中心</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="optManualPage"><i class="el-icon-document"></i>&nbsp;管理员操作手册</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="loginOut"><i class="el-icon-back"></i>&nbsp;退出登录</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import header_logo from '@/assets/img/headerLogoNew.png'
import userHeadImage from '@/assets/img/trialCenter/userHeadImage.png'
import { logoutApi, trialUrl } from '@/js/api'
import {enterPriseDetailInfo,NotifyAuditPassedApi} from '@/js/enterPriseApi'
import Bus from '@/js/bus'
import store from '@/store'
import  {BASE_URL} from "../../../config/env";
import * as signalR from '@microsoft/signalr'
export default {
  name: 'Home',
  props: {
    title: {
      type: String,
      default: '个人中心'
    }
  },
  data () {
    return {
      connection:null,
      userHeadImage,
      header_logo,
      user: {
        userName: '**', // 用户名称
        photo: '', // 用户头像
        defaultPhoto: '' // 默认头像
      },
      useraccount: localStorage.getItem('userAccount')
        ? localStorage.getItem('userAccount')
        : '',
      showUser: localStorage.getItem('logined')
        ? localStorage.getItem('logined')
        : 0,
      companyLogo:null,
    }
  },
  filters:{
    userNameFilter(val){
      if(val.length>15){
        return val.substr(0,15)+'...'
      }else{
        return val
      }
    }
  },
  created () {
    this.getenterPriseDetailInfo();
    this.initsignalR()
  },
  mounted () {
    Bus.$on('updateCompanyName', params => {
      console.log('更新用户信息', params)
      this.user.userName =params
    })
    Bus.$on('signalRupdate', params => {
      this.connection.stop()
      this.initsignalR()
    })
  },
  beforeDestroy(){
    Bus.$off('updateCompanyName')
    Bus.$off('signalRupdate')//消息推送停止监听
    this.connection.stop()
  },
  methods: {
    initsignalR(){
        let that=this
        let token=window.localStorage.getItem('token').split('Bearer ')[1]
        let url=BASE_URL.TEST_HOST_API
        let hubUrl=url.split('/pkpmuser-api')[0]+'/UserNotify'
        this.connection = new signalR.HubConnectionBuilder()
            .withAutomaticReconnect()//断线自动重连
            .withUrl(hubUrl,{
              skipNegotiation: true,
              transport:signalR.HttpTransportType.WebSockets,
              accessTokenFactory: () => token
            })//传递参数Query["access_token"]
            .build()
        this.connection.serverTimeoutInMilliseconds=60000
        this.connection.start()
        .catch(err => {
            console.log(err)
        })
        //自动重连成功后的处理
        this.connection.onreconnected(connectionId => {
            console.log(connectionId,'重连成功')
        })
        //接受消息的处理
        this.connection.on('OnCancelAuditPassed', function(data) {
            console.log(data)
            console.log(data.indexOf('已解散')!=-1)
            
            if(data.indexOf('已解散')!=-1){
              that.$message.error(data)
              that.$router.push('/companyLogoffTipage')
            }
        })
    },
    optManualPage(){
      window.open('https://doc.pkpm.cn/docs/gly','_blank')
    },
    send(){
      NotifyAuditPassedApi({
          message:'123'
        })
        .then(res=>{
          console.log(res)
        })
        .catch(err=>{
          console.log(err)
        })
    },
    reloadcompanyName(){
      this.getenterPriseDetailInfo()
    },
    loginOut () {
      logoutApi()
        .then(res => {
          this.$router.push({
            name: 'login',
            query: { direct: this.router.name }
          })
          localStorage.clear()
          // xj清除企业认证状态
          this.$store.commit('setCurrentVerifystatus', '')
        })
        .catch(() => {
          this.$router.push({ name: 'login' })
          localStorage.clear()
          // xj清除企业认证状态
          this.$store.commit('setCurrentVerifystatus', '')
        })
    },
    goLogin () {
      console.log(this.$route)
      this.$router.push({
        name: 'login',
        query: {
          direct: this.$route.name
        }
      })
    },
    personInfo () {
        // pc端跳转
        let statusflag = window.localStorage.getItem('enterPriseId')
        if (statusflag) { // 企业管理员
          this.$emit('companyPercenterClick')
        } else { // 个人用户,企业用户
          console.log('个人中心点击')
          this.$store.commit('setCurrentCompany', '个人')
          this.$router.push({ name: 'TryOutRequest' })
        }
    },
    getenterPriseDetailInfo(){//先获取企业详细信息
      let that=this;
      let params={
          enterPriseId:window.localStorage.getItem('enterPriseId')
      };
      enterPriseDetailInfo(params)
      .then(res=>{
          if(res.status===200 && res.data.error_code===0){
              const {data}=res.data;
              if(data===null){
                  console.log('1')
              }else{
                    that.user.userName=data.enterpriseName;
                    that.companyLogo=data.logoImageInAliyunOSSViewPath       
              }
          }else{
              this.$message.error(res.data.error_msg)
          }
      })
      .catch(err=>{
          console.log(err)
          if(err.data && err.data.errorMessages){
              that.$message.error(err.data.errorMessages[0]);
          }
      })
    },
    // 跳转官网链接
    clickHeaderPic () {
      console.log(111)
      let tokenBear = localStorage.getItem('token')
      let token = []
      if (tokenBear) {
        token = tokenBear.split('Bearer ')
      }
      console.log(token)
      let dirToken = token.length > 1 ? token[1] : undefined
      console.log(dirToken)
      window.location.href =
        trialUrl + '/login?token=' + dirToken + '&direct=' + trialUrl + '/home'
    }
  }
}
</script>

<style lang="scss" scoped>
#Hearder_company {
    height: 74px;
    width: 100%;
    font-family: PingFangSC-Medium;
    font-size: 22px;
    background-size: cover;
    color: #ffffff;
  .header_content_company {
    height: 74px;
    font-family: PingFangSC-Medium;
    font-size: 22px;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-wraper_companyhead{
      display: flex;
      align-items: center;
      .header_title{
        padding-left: 10px;
      }
      .header_logo {
        cursor: pointer;
        height: 24px;
        line-height: 24px;
      }
    }
    .right-wraper_companyhead{
      display: flex;
      font-size: 14px;
    }
  }
  /deep/ .el-dropdown {
    margin-right: 40px;
    .headerlogin {
      color: #fff;
      display: flex;
      align-items: center;
      .avator {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .login_register {
      cursor: pointer;
    }
  }

  /deep/ .el-dropdown-menu__item {
    text-align: center;
  }
}
/deep/ .el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/view/CompanyUser/companyHeader.vue